import React, { useState } from 'react';

import styled from 'styled-components';

import ListCard from '../ListCard';
import ModalFullScreenCard from '../ModalFullScreenCard';
import Text from '../../Text';

const Title = styled(Text)`
  margin-bottom: 24px;
`;

const Description = styled(Text)`
  a {
    color: ${({ theme }) => theme.colors.gray800};
  }
`;

const DocumentCardMobile = ({ title, description }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ListCard icon="ic-outline-help-18.svg" action={() => setShowModal(true)}>
        {title}
      </ListCard>
      <ModalFullScreenCard show={showModal} closeAction={() => setShowModal(false)}>
        <Title type="H6-w400" color="gray800">
          {title}
        </Title>
        <Description type="Subtitle-1-w400" color="gray700">
          {description}
        </Description>
      </ModalFullScreenCard>
    </>
  );
};

export default DocumentCardMobile;
